//---------------React/Redux
import React from 'react';

//---------------Components
import { ImageUploadInput } from '../../../form/imageUploadInput';

//---------------Constants
import {
  uploadTypes,
  imageFormats,
  getFullImagePathByType
} from '../../../../constants/imageUpload';

class AboutImageUpload extends React.Component {
  render() {
    return (
      <div>
        <ImageUploadInput
          format={imageFormats}
          height={500}
          width={1500}
          position="left"
          entity={this.props.entity}
          uploadType={uploadTypes.ASSET}
          url={getFullImagePathByType(this.props.value, uploadTypes.ASSET)}
          onChange={this.props.onValueChange}
        />
      </div>
    );
  }
}

export default AboutImageUpload;
